import { css } from 'emotion';
import { space } from '@joykit';

export namespace styles {
  export const headerContainer = css({
    margin: '0 0 1rem 0',
    textAlign: 'center',
    '@media(min-width: 678px)': {
      margin: space.stack.xl
    }
  });

  export const header = css({
    fontFamily: 'PT serif',
    fontSize: '40px',
    lineHeight: '45px',
    fontWeight: 'normal',
    margin: space.stack.md
  });

  export const subtitle = css({
    color: '#888888',
    fontSize: '18px',
    lineHeight: '25px',
    width: '600px',
    margin: '0 auto',
    maxWidth: '100%'
  });
}
